let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.render()
  }

  setupListeners () {
    super.setupListeners()

    this.handleDropdownMouseEnter = this.handleDropdownMouseEnter.bind(this)
    this.handleDropdownMouseLeave = this.handleDropdownMouseLeave.bind(this)
    this.handlePanelFocusOut = this.handlePanelFocusOut.bind(this)
    this.handleToggleClick = this.handleToggleClick.bind(this)
    this.handleSubmenuTriggerMouseEnter =
      this.handleSubmenuTriggerMouseEnter.bind(this)
    this.handleSubmenuTriggerMouseLeave =
      this.handleSubmenuTriggerMouseLeave.bind(this)
    this.handleMenuGroupAnchorMouseEnter =
      this.handleMenuGroupAnchorMouseEnter.bind(this)

    this.submenus.forEach((submenu) => {
      this.listeners.add(
        submenu.dropdown,
        'mouseenter',
        this.handleDropdownMouseEnter,
      )
      this.listeners.add(
        submenu.dropdown,
        'mouseleave',
        this.handleDropdownMouseLeave,
      )
      this.listeners.add(submenu.panel, 'focusout', this.handlePanelFocusOut)
      this.listeners.add(submenu.toggle, 'click', this.handleToggleClick)

      const menuGroupAnchor = document.querySelector(
        '[data-desktop-menu-el="menuGroupAnchor"]',
      )
      if (menuGroupAnchor) {
        this.listeners.add(
          menuGroupAnchor,
          'mouseenter',
          this.handleMenuGroupAnchorMouseEnter,
        )
      }

      const submenuTriggers = submenu.panel.querySelectorAll(
        '[data-desktop-menu-el="menuTrigger"]',
      )
      submenuTriggers.forEach((submenuTrigger) => {
        this.listeners.add(
          submenuTrigger,
          'mouseenter',
          this.handleSubmenuTriggerMouseEnter,
        )
        this.listeners.add(
          submenuTrigger,
          'mouseleave',
          this.handleSubmenuTriggerMouseLeave,
        )
      })

      const regularTextLinks = submenu.panel.querySelectorAll(
        '[data-desktop-menu-el="menuLinkText"]',
      )
      regularTextLinks.forEach((regularTextLink) => {
        this.listeners.add(
          regularTextLink,
          'mouseenter',
          this.handleSubmenuTriggerMouseEnter,
        )
        this.listeners.add(
          regularTextLink,
          'mouseleave',
          this.handleSubmenuTriggerMouseLeave,
        )
      })

      const thirdLevelLinks = submenu.panel.querySelectorAll(
        '[data-desktop-menu-level="thirdLevel"]',
      )
      thirdLevelLinks.forEach((list) => {
        this.listeners.add(
          list,
          'mouseenter',
          this.handleThirdLevelLinkMouseEnter,
        )
        this.listeners.add(
          list,
          'mouseleave',
          this.handleThirdLevelLinkMouseLeave,
        )
      })
    })

    // Add listeners for third-level links

    window.addEventListener('resize', this.updateMenuWidths)
  }

  handleMenuGroupAnchorMouseEnter (event) {
    // Remove active classes from all menuList elements
    const allMenuLists = document.querySelectorAll(
      '[data-desktop-menu-el="menuList"]',
    )
    allMenuLists.forEach((menuList) => {
      menuList.classList.remove('hd-Dropdown_Items-active')
    })

    // Optionally, toggle all submenus to be closed
    this.submenus.forEach((submenu) => {
      this.toggleSubmenu(submenu, false)
    })
  }

  /** @param {PointerEvent} event */
  handleDropdownMouseEnter (event) {
    const id = event.currentTarget.dataset.dropdownId
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    this.toggleSubmenu(submenu, true)

    this.updateMenuWidths()
  }

  /** @param {PointerEvent} event */
  handleDropdownMouseLeave (event) {
    const id = event.currentTarget.dataset.dropdownId
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    if (
      event.relatedTarget &&
      (event.relatedTarget.closest('[data-dropdown-id]') ||
        event.relatedTarget.closest('[data-desktop-menu-el="menuList"]'))
    ) {
      return
    }

    // Remove active classes from all menuList elements
    const allMenuLists = document.querySelectorAll(
      '[data-desktop-menu-el="menuList"]',
    )
    allMenuLists.forEach((menuList) => {
      menuList.classList.remove('hd-Dropdown_Items-active')
    })

    this.toggleSubmenu(submenu, false)
  }

  /** @param {FocusEvent} event */
  handlePanelFocusOut (event) {
    const id = event.currentTarget.id
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    const focusIsStillInPanel = submenu.panel.contains(event.relatedTarget)

    if (focusIsStillInPanel) {
      return
    }

    this.toggleSubmenu(submenu, false)
  }

  /** @param {PointerEvent} event */
  handleToggleClick (event) {
    const id = event.currentTarget.getAttribute('aria-controls')
    const submenu = this.submenus.find((submenu) => submenu.id === id)

    this.toggleSubmenu(submenu, !submenu.isVisible)

    this.updateMenuWidths()
  }

  handleSubmenuTriggerMouseEnter (event) {
    clearTimeout(this.submenuCloseTimeout)

    const trigger = event.currentTarget
    const menuGroup = trigger.closest('[data-desktop-menu-el="menuGroup"]')

    if (trigger.dataset.desktopMenuEl !== 'menuLinkText') {
      const menuList = menuGroup.querySelector(
        '[data-desktop-menu-el="menuList"]',
      )
      if (menuList) {
        const currentLevel = trigger.closest('[data-desktop-menu-level]')
          ?.dataset.desktopMenuLevel

        if (currentLevel === 'firstLevel') {
          // Hide all second-level menus that are not in the current menu group
          const secondLevelMenuLists = document.querySelectorAll(
            '[data-desktop-menu-level="secondLevel"]',
          )
          secondLevelMenuLists.forEach((secondLevelMenuList) => {
            if (!menuGroup.contains(secondLevelMenuList)) {
              secondLevelMenuList.classList.remove('hd-Dropdown_Items-active')
            }
          })

          // Hide all third-level menus
          const thirdLevelMenuLists = document.querySelectorAll(
            '[data-desktop-menu-level="thirdLevel"]',
          )
          thirdLevelMenuLists.forEach((thirdLevelMenuList) => {
            thirdLevelMenuList.classList.remove('hd-Dropdown_Items-active')
          })

          // Show the current first-level menu's second-level menu
          menuList.classList.add('hd-Dropdown_Items-active')
        } else if (currentLevel === 'secondLevel') {
          // Hide all third-level menus that are not in the current menu group
          const thirdLevelMenuLists = document.querySelectorAll(
            '[data-desktop-menu-level="thirdLevel"]',
          )
          thirdLevelMenuLists.forEach((thirdLevelMenuList) => {
            if (!menuGroup.contains(thirdLevelMenuList)) {
              thirdLevelMenuList.classList.remove('hd-Dropdown_Items-active')
            }
          })

          // Show the submenu for the current second-level trigger
          const submenuHandles =
            trigger.dataset.desktopSubmenuHandles.split(',')
          submenuHandles.forEach((handle) => {
            const matchingMenuLists = document.querySelectorAll(
              `[data-desktop-submenu-handle="${handle.trim()}"]`,
            )
            matchingMenuLists.forEach((menuList) => {
              menuList.classList.add('hd-Dropdown_Items-active')
            })
          })
        } else if (currentLevel === 'thirdLevel') {
          // Show the submenu for the current third-level trigger
          const submenuHandles =
            trigger.dataset.desktopSubmenuHandles.split(',')
          submenuHandles.forEach((handle) => {
            const matchingMenuLists = document.querySelectorAll(
              `[data-desktop-submenu-handle="${handle.trim()}"]`,
            )
            matchingMenuLists.forEach((menuList) => {
              menuList.classList.add('hd-Dropdown_Items-active')
            })
          })
        }
      }
    } else {
      const currentLevel = trigger.closest('[data-desktop-menu-level]')?.dataset
        .desktopMenuLevel

      if (currentLevel === 'secondLevel') {
        const thirdLevelMenuLists = document.querySelectorAll(
          '[data-desktop-menu-level="thirdLevel"]',
        )

        thirdLevelMenuLists.forEach((thirdLevelMenuList) => {
          thirdLevelMenuList.classList.remove('hd-Dropdown_Items-active')
        })
      }
    }

    this.lastMenuLevel = trigger.closest(
      '[data-desktop-menu-level]',
    )?.dataset.desktopMenuLevel
  }

  handleSubmenuTriggerMouseLeave (event) {
    clearTimeout(this.submenuCloseTimeout)

    const trigger = event.currentTarget
    const menuGroup = trigger.closest('[data-desktop-menu-el="menuGroup"]')
    const currentMenuLevel = trigger.closest('[data-desktop-menu-level]')
      ?.dataset.desktopMenuLevel

    if (menuGroup) {
      const menuList = menuGroup.querySelector(
        '[data-desktop-menu-el="menuList"]',
      )
      if (menuList) {
        if (currentMenuLevel === 'firstLevel') {
          // Close second and third-level menus if moving from second to first level
          const secondLevelMenuLists = document.querySelectorAll(
            '[data-desktop-menu-level="secondLevel"]',
          )
          secondLevelMenuLists.forEach((secondLevelMenuList) => {
            if (!menuGroup.contains(secondLevelMenuList)) {
              secondLevelMenuList.classList.remove('hd-Dropdown_Items-active')
            }
          })

          const thirdLevelMenuLists = document.querySelectorAll(
            '[data-desktop-menu-level="thirdLevel"]',
          )
          thirdLevelMenuLists.forEach((thirdLevelMenuList) => {
            thirdLevelMenuList.classList.remove('hd-Dropdown_Items-active')
          })
        } else if (currentMenuLevel === 'secondLevel') {
          // Close third-level menus if moving from third to second level
          const thirdLevelMenuLists = document.querySelectorAll(
            '[data-desktop-menu-level="thirdLevel"]',
          )
          thirdLevelMenuLists.forEach((thirdLevelMenuList) => {
            if (!menuGroup.contains(thirdLevelMenuList)) {
              thirdLevelMenuList.classList.remove('hd-Dropdown_Items-active')
            }
          })
        } else if (currentMenuLevel === 'thirdLevel') {
          // Hide third-level menu if moving out of it
          const submenuHandles =
            trigger.dataset.desktopSubmenuHandles.split(',')
          submenuHandles.forEach((handle) => {
            const matchingMenuLists = document.querySelectorAll(
              `[data-desktop-submenu-handle="${handle.trim()}"]`,
            )
            matchingMenuLists.forEach((menuList) => {
              menuList.classList.remove('hd-Dropdown_Items-active')
            })
          })
        }
      }
    }

    this.lastMenuLevel = currentMenuLevel
  }

  handleThirdLevelLinkMouseEnter (event) {
    const thirdLevelLink = event.currentTarget
    const thirdLevelMenu = thirdLevelLink.closest(
      '[data-desktop-menu-level="thirdLevel"]',
    )

    if (thirdLevelMenu) {
      const thirdLevelHandle = thirdLevelMenu.dataset.desktopSubmenuHandle

      // Find the closest secondLevel menu group
      const secondLevelMenuGroup = thirdLevelMenu
        .closest('ul[data-desktop-menu-level="secondLevel"]')
        .querySelectorAll('li[data-desktop-menu-el="menuGroup"]')

      secondLevelMenuGroup.forEach((item) => {
        const menuTriggers = item.querySelector(
          '[data-desktop-menu-el="menuTrigger"]',
        )

        // Check if handles match
        if (menuTriggers.dataset.desktopSubmenuHandle === thirdLevelHandle) {
          menuTriggers.classList.add('drw-Navigation_Link-activeGroup')
        }
      })
    }
  }

  handleThirdLevelLinkMouseLeave (event) {
    const thirdLevelLink = event.currentTarget
    const thirdLevelMenu = thirdLevelLink.closest(
      '[data-desktop-menu-level="thirdLevel"]',
    )

    if (thirdLevelMenu) {
      const thirdLevelHandle = thirdLevelMenu.dataset.desktopSubmenuHandle

      // Find the closest secondLevel menu group
      const secondLevelMenuGroup = thirdLevelMenu
        .closest('ul[data-desktop-menu-level="secondLevel"]')
        .querySelectorAll('li[data-desktop-menu-el="menuGroup"]')

      secondLevelMenuGroup.forEach((item) => {
        const menuTriggers = item.querySelector(
          '[data-desktop-menu-el="menuTrigger"]',
        )

        // Check if handles match
        if (menuTriggers.dataset.desktopSubmenuHandle === thirdLevelHandle) {
          menuTriggers.classList.remove('drw-Navigation_Link-activeGroup')
        }
      })
    }
  }

  /**
   * @param {HeaderDropdown['submenus'][number]} activeSubmenu
   * @param {boolean} force
   */
  toggleSubmenu (activeSubmenu, force) {
    this.submenus.forEach((submenu) => {
      const isVisible = submenu.id === activeSubmenu.id ? force : false

      submenu.toggle.setAttribute('aria-expanded', isVisible)
      submenu.panel.setAttribute('aria-hidden', !isVisible)
    })
  }

  updateMenuWidths () {
    const referenceElement = document.querySelector(
      '[data-header-dropdown-el="nonPromoList"]',
    )
    const targetElements = document.querySelectorAll('ul.hd-Dropdown_Items')

    if (referenceElement) {
      const referenceWidth = referenceElement.offsetWidth

      targetElements.forEach((element) => {
        element.style.width = `${referenceWidth + 20}px`
      })
    }
  }

  render () {
    if (dropdownLoaded) return

    const SECTION = 'header'

    window.BAO.sectionRenderer
      .fetch(SECTION, `${window.Shopify.routes.root}?view=dropdown`)
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res[SECTION])
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  get submenus () {
    if (!this.els.dropdown || !this.els.toggle || !this.els.panel) {
      return []
    }

    const dropdowns = this.els.dropdown?.elements ?? []
    const panels = this.els.panel?.elements ?? []
    const toggles = this.els.toggle?.elements ?? []

    return dropdowns.map((dropdown) => {
      const id = dropdown.dataset.dropdownId
      const panel = panels.find((panel) => panel.id === id)
      const toggle = toggles.find(
        (toggle) => toggle.getAttribute('aria-controls') === id,
      )

      return {
        dropdown,
        id,
        isVisible: panel.getAttribute('aria-hidden') === 'false',
        panel,
        toggle,
      }
    })
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
